export type State = {
  isLoggedIn: boolean;
};

export const state: State = {
  isLoggedIn: false,
};
